import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@/redux/modules/value/profileSidebar/profileSidebar.module";

import ProfileMenuButton from "./profileMenuButton.component";

const ProfileMenuButtonContainer = () => {
    const dispatch = useThunkDispatch();
    const sidebarActive = useSelector(HeaderSelectors.isSidebarActive);

    const handleOnClick = () => {
        if (sidebarActive) return;

        dispatch(
            ProfileSidebarModule.update({
                active: true
            })
        );
    };

    return <ProfileMenuButton onClick={handleOnClick} />;
};

export { ProfileMenuButtonContainer };
